import React from "react";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import PhoneIcon from "@material-ui/icons/Phone";
import CakeIcon from "@material-ui/icons/Cake";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";
import PublicIcon from "@material-ui/icons/Public";
import StreetviewIcon from "@material-ui/icons/Streetview";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import AddLocationIcon from "@material-ui/icons/AddLocation";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import LockIcon from "@material-ui/icons/Lock";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
var today;
today = new Date();
var dd = String(today.getDate()).padStart(2, "0");
var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
var yyyy = today.getFullYear();

today = yyyy + "-" + mm + "-" + dd;
let inquiryData = {
  general: {
    emailaddress1: {
      elementType: "input",
      elementConfig: {
        type: "email",
        label: "Email",
        autoComplete: "Email",
        name: "emailaddress1",
        fullWidth: true,
      },
      icon: <MailOutlineIcon style={{ color: "#959595" }} />,
      value: "",
    },
    donotsendmm: {
      elementType: "select",
      elementConfig: {
        label: "Send Information?",
        options: [],
        name: "donotsendmm",
      },
      value: "",
    },
    ses_academicinterest: {
      elementType: "select",
      elementConfig: {
        label: "What is your Academic Interest?",
        options: [],
        name: "ses_academicinterest",
      },
      value: "",
    },
    _ses_certificationprogram_value: {
      elementType: "select",
      elementConfig: {
        label: "To what Certification Program do you want to apply?",
        options: [],
        name: "_ses_certificationprogram_value",
      },
      value: "",
    },
    ses_fullparttime: {
      elementType: "select",
      elementConfig: {
        label: "Are you applying for Full or Part Time?",
        options: [],
        name: "ses_fullparttime",
      },
      value: "",
    },
  },
  conatactInformation: {
    salutation: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Salutation",
        autoComplete: "Salutation",
        name: "salutation",
        required: true,
        fullWidth: true,
      },
      icon: <SupervisorAccountIcon style={{ color: "#959595" }} />,
      value: "",
    },
    firstname: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "First Name",
        autoComplete: "first-name",
        name: "firstname",
        required: true,
        fullWidth: true,
      },
      icon: <AccountBoxIcon style={{ color: "#959595" }} />,
      value: "",
    },
    middlename: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Middle Name",
        autoComplete: "middle-name",
        name: "middlename",
        required: true,
        fullWidth: true,
      },
      icon: <AccountBoxIcon style={{ color: "#959595" }} />,
      value: "",
    },
    lastname: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Last Name",
        autoComplete: "last-name",
        name: "lastname",
        required: true,
        fullWidth: true,
      },
      icon: <AccountBoxIcon style={{ color: "#959595" }} />,
      value: "",
    },
    ses_birthdate: {
      elementType: "date",
      label: "Birthday *",
      elementConfig: {
        type: "text",
        autoComplete: "off",
        name: "ses_birthdate",
        required: true,
        fullWidth: true,
        // autoFocus:false,
        InputLabelProps: {
          shrink: true,
        },
        autoFocus: false,
      },
      icon: <CakeIcon style={{ color: "#959595" }} />,
      value: "",
    },
    mobilephone: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Mobile Phone",
        autoComplete: "mobile-phone",
        name: "mobilephone",
        required: true,
        fullWidth: true,
      },
      icon: <PhoneAndroidIcon style={{ color: "#959595" }} />,
      value: "",
    },
    telephone1: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Home Phone",
        autoComplete: "mobile-phone",
        name: "telephone1",
        required: true,
        fullWidth: true,
      },
      icon: <PhoneIcon style={{ color: "#959595" }} />,
      value: "",
    },
    preferredcontactmethodcode: {
      elementType: "select",
      elementConfig: {
        label: "Preferred Method of Contact",
        options: [],
        name: "preferredcontactmethodcode",
      },
      value: "1",
    },
    qualificationcomments: {
      elementType: "textArea",
      elementConfig: {
        name: "qualificationcomments",
      },
      value: "",
    },
  },
  homeAddress: {
    address1_country: {
      elementType: "select",
      elementConfig: {
        options: [],
        label: "Country *",
        name: "address1_country",
        required: true,
      },
      value: "",
      display: "block",
    },
    address1_line1: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Street",
        autoComplete: "Street",
        name: "address1_line1",
        required: true,
        fullWidth: true,
      },
      icon: <StreetviewIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address1_city: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "City",
        autoComplete: "City",
        name: "address1_city",
        required: true,
        fullWidth: true,
      },
      icon: <LocationCityIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address1_stateorprovince: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "State or Province",
        autoComplete: "State or Province",
        name: "address1_stateorprovince",
        required: true,
        fullWidth: true,
      },
      icon: <LocationCityIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address1_postalcode: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Zip Code/Postal Code",
        autoComplete: "Zip Code/Postal Code",
        name: "address1_postalcode",
        required: true,
        fullWidth: true,
      },
      icon: <AddLocationIcon style={{ color: "#959595" }} />,
      value: "",
    },
  },
  mailingAddress: {
    address2_country: {
      elementType: "select",
      elementConfig: {
        options: [],
        label: "Country",
        name: "address2_country",
      },
      name: "address2_country",
      value: "",
      display: "block",
    },
    address2_line1: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Street",
        autoComplete: "Street",
        name: "address2_line1",

        fullWidth: true,
      },
      icon: <StreetviewIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address2_city: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "City",
        autoComplete: "City",
        name: "address2_city",

        fullWidth: true,
      },
      icon: <LocationCityIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address2_stateorprovince: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "State or Province",
        autoComplete: "State or Province",
        name: "address2_stateorprovince",
        fullWidth: true,
      },
      icon: <LocationCityIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address2_postalcode: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Zip Code/Postal Code",
        autoComplete: "Zip Code/Postal Code",
        name: "address2_postalcode",
        fullWidth: true,
      },
      icon: <AddLocationIcon style={{ color: "#959595" }} />,
      value: "",
    },
  },
};

export default inquiryData;
